export default "__VITE_ASSET__2vSUAs_x__"